export default class UBTHelper {
  static bindData() {}

  static send() {}

  static sendError() {}

  static pageView() {}

  static clickButton() {}

  static payment() {}

  static bindUserInfo() {}

  static getAppSsid() {}

  static clickResource() {}
}
